import GetRequest from "../utilities/api/get-request";
import PostRequest from "../utilities/api/post-request";
import DeleteRequest from "../utilities/api/delete-request";

class FaireProduct {
  // Get products (faire)
  static async get(filterParameters = {}) {
    const path = "/api/products/faire";

    return await GetRequest(path, filterParameters);
  }

  // Delete faire product
  static async delete(productId) {
    const path = `/api/products/faire/${productId}`;

    return await DeleteRequest(path);
  }

  // Import products (faire)
  static async import(data = {}) {
    const path = "/api/products/faire/import";

    return await PostRequest(path, data);
  }

  //  Upload faire product to wix
  static async uploadToWix(productId) {
    let data = {
      export: [{ product_id: productId }],
    };
    const path = "/api/products/faire/export";

    return await PostRequest(path, data);
  }

  // Export faire product(s) to wix
  static async export(productIds) {
    let data = {
      export: productIds,
    };

    const path = "/api/products/faire/export/bulk";
    return await PostRequest(path, data);
  }

  // Get faire Store Overview
  static async getFaireStoreDetails() {
    const path = "/api/dashboard/faire/detail";

    return await GetRequest(path);
  }

  // Check If Similar Sku Exists on Faire
  static async checkProductWithSameSkuExists(filterParameters = {}) {
    const path = "/api/variants/faire/check-similar-sku";

    return await GetRequest(path, filterParameters);
  }
}

export default FaireProduct;
